/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Brand } from './Brand';
import {
    BrandFromJSON,
    BrandFromJSONTyped,
    BrandToJSON,
} from './Brand';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { SingleDetectorConnectorType } from './SingleDetectorConnectorType';
import {
    SingleDetectorConnectorTypeFromJSON,
    SingleDetectorConnectorTypeFromJSONTyped,
    SingleDetectorConnectorTypeToJSON,
} from './SingleDetectorConnectorType';

/**
 * 
 * @export
 * @interface CreateUnicheckSimulatorDto
 */
export interface CreateUnicheckSimulatorDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateUnicheckSimulatorDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUnicheckSimulatorDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof CreateUnicheckSimulatorDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateUnicheckSimulatorDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {Brand}
     * @memberof CreateUnicheckSimulatorDto
     */
    brand1?: Brand;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof CreateUnicheckSimulatorDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {SingleDetectorConnectorType}
     * @memberof CreateUnicheckSimulatorDto
     */
    singleDetectorConnectorType?: SingleDetectorConnectorType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUnicheckSimulatorDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    $type?: CreateUnicheckSimulatorDtoTypeEnum;
}


/**
 * @export
 */
export const CreateUnicheckSimulatorDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCreateUnicheckSimulatorDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateUnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateUnicheckSimulatorDtoTypeEnum = typeof CreateUnicheckSimulatorDtoTypeEnum[keyof typeof CreateUnicheckSimulatorDtoTypeEnum];


/**
 * Check if a given object implements the CreateUnicheckSimulatorDto interface.
 */
export function instanceOfCreateUnicheckSimulatorDto(value?: unknown): value is CreateUnicheckSimulatorDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateUnicheckSimulatorDtoTypeEnum)[0];
}

export function CreateUnicheckSimulatorDtoFromJSON(json: any): CreateUnicheckSimulatorDto {
    return CreateUnicheckSimulatorDtoFromJSONTyped(json, false);
}

export function CreateUnicheckSimulatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUnicheckSimulatorDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'typeNumber': !exists(json, 'typeNumber') ? undefined : json['typeNumber'],
        'brand1': !exists(json, 'brand1') ? undefined : BrandFromJSON(json['brand1']),
        'deviceInterfaceType': !exists(json, 'deviceInterfaceType') ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'defaultImageId': !exists(json, 'defaultImageId') ? undefined : json['defaultImageId'],
        'singleDetectorConnectorType': !exists(json, 'singleDetectorConnectorType') ? undefined : SingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'isRegistrable': !exists(json, 'isRegistrable') ? undefined : json['isRegistrable'],
        'serialNumber': json['serialNumber'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateUnicheckSimulatorDtoToJSON(value?: CreateUnicheckSimulatorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'description': value.description,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isAvailable': value.isAvailable,
        'imageId': value.imageId,
        'subCategory': QaEquipmentSubCategoryToJSON(value.subCategory),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'typeNumber': value.typeNumber,
        'brand1': BrandToJSON(value.brand1),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value.deviceInterfaceType),
        'defaultImageId': value.defaultImageId,
        'singleDetectorConnectorType': SingleDetectorConnectorTypeToJSON(value.singleDetectorConnectorType),
        'isRegistrable': value.isRegistrable,
        'serialNumber': value.serialNumber,
        '$type': value.$type,
    });
}

